const React = require('react');
const toastIcon = require('../../asset/images/warning-white.svg');

module.exports = React.createClass({
  displayName: 'Toast',
  propTypes: {
    clearErrorMsg: React.PropTypes.func.isRequired,
    errorMessage: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.element,
    ]).isRequired,
    tapHidden: React.PropTypes.bool,
    timeout: React.PropTypes.number,
    isShowIcon: React.PropTypes.bool,
  },
  getDefaultProps() {
    return { timeout: 1500, isShowIcon: true };
  },
  componentWillMount() {
    const { clearErrorMsg, timeout } = this.props;
    if (timeout === -1) {
      return;
    }
    this.timeout = setTimeout(() => {
      clearErrorMsg();
    }, timeout);
  },
  componentDidMount() {
    if (this.refs && this.refs.toast) {
      this.refs.toast.focus();
    }
  },
  tapToast(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    const { tapHidden, clearErrorMsg } = this.props;

    if (tapHidden) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      clearErrorMsg();
    }
  },
  render() {
    const { errorMessage, isShowIcon } = this.props;

    if (typeof errorMessage === 'object' && !React.isValidElement(errorMessage)) {
      return false;
    }

    return (
      <div className="c-toast" onTouchTap={evt => this.tapToast(evt)} ref="toast" tabIndex="-1">
        <div className="c-toast__content">
          {isShowIcon && (<img src={toastIcon} style={{ width: 28 }} alt="" />)}
          {errorMessage}
        </div>
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/mui/toast.jsx